import React, { useEffect } from 'react';
import ReactPlayer from 'react-player';
import { useDispatch, useSelector } from 'react-redux';
import {
  getActiveVideo,
  getEngineVideoUrl,
  getPushStartVideoUrl,
  getShowVideo,
  showVideoToggled,
} from '../../store/car-slice';
import { Dialog } from '..';
import { useWindowSize } from '../../hooks/use-window-size';
import { Box, Skeleton } from '@mui/material';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

import theme from '../../config/theme';
import FabControlled from '../fab/fab-controlled';

export default function VideoPlayer() {
  const dispatch = useDispatch();

  // Selectors
  const [videoSrc, setVideoSrc] = React.useState({
    'push-start': '',
    engine: '',
  });
  const [loading, setLoading] = React.useState(true);

  // Selectors
  const showVideo = useSelector(getShowVideo);

  const pushStartUrl = useSelector(getPushStartVideoUrl);
  const engineUrl = useSelector(getEngineVideoUrl);
  const activeVideo = useSelector(getActiveVideo);
  // Hooks
  const { width, height } = useWindowSize();

  const handleToggle = () => dispatch(showVideoToggled());

  const getVideoUrl = () => {
    let url = null;

    if (activeVideo === 'push-start') {
      url = pushStartUrl;
    } else if (activeVideo === 'engine') {
      url = engineUrl;
    }

    return url;
  };

  const urlToBlob = async () => {
    setLoading(true);
    if (!activeVideo) return;
    if (videoSrc[activeVideo] !== '') return;
    const url = getVideoUrl();
    if (!url) return;

    const blob = await fetch(url).then((response) => response.blob());

    setVideoSrc({ ...videoSrc, [activeVideo]: URL.createObjectURL(blob) });

    setLoading(false);
  };

  useEffect(() => {
    urlToBlob();
  }, [activeVideo]);

  const closeButton = (
    <Box
      sx={{
        zIndex: theme.zIndex.modal + 1,
        right: 7,
        top: 7,
        position: 'absolute',
      }}
    >
      <FabControlled Icon={CloseRoundedIcon} onClick={handleToggle} />
    </Box>
  );

  const renderContent = showVideo && (
    <Box
      height={
        width < 715 ? width / 2 + 20 : height < 430 ? height / 1.3 : '540px'
      }
      sx={{
        position: 'relative',
        overflow: 'hidden',
      }}
      width={
        width < 1000 ? width / 1.1 : width < 715 ? width / 1.4 + 100 : '960px'
      }
    >
      {closeButton}
      <Skeleton
        height={
          width < 715 ? width / 2 + 20 : height < 430 ? height / 1.3 : '540px'
        }
        sx={{
          display: loading ? 'block' : 'none',
          borderRadius: 5,
          boxShadow: '0 0 9px -2px #454545',
          background: '#8d8d8d',
          objectFit: 'cover',
          transition: 'translate 300ms ease-in-out',
          transform: 'none',
        }}
        width={
          width < 1000 ? width / 1.1 : width < 715 ? width / 1.4 + 100 : '960px'
        }
      />

      <ReactPlayer
        controls
        height="100%"
        onReady={() => {
          if (activeVideo && videoSrc[activeVideo]) {
            setLoading(false);
          }
        }}
        playing
        progressInterval={1000}
        style={{ display: loading ? 'none' : 'block', borderRadius: '1rem' }}
        url={activeVideo ? videoSrc[activeVideo] : ''}
        width="100%"
      />
    </Box>
  );

  return (
    <Dialog
      handleClose={handleToggle}
      open={showVideo}
      renderContent={renderContent}
    />
  );
}
